import { useState, useEffect, useRef } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

import { FormInput } from "../../components/forms/form-input";
import { SiteHeader } from "../../components/header/header";
import { AppAlert } from "../../components/utils/alert";
import { useAuthentication } from "../../../services/authentication/authentication.context";
import { LoadingIndicator } from "../../components/utils/loader";
import { isNull } from "../../_helpers/isNull";


export const LoginPage = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [onAlert, setOnAlert] = useState();

    const { accountLogin, isLoading, isAuthenticated } = useAuthentication();

    const subBttn = useRef();

    const handleSubmit = async () => {
        if (isNull(userEmail) || isNull(userPassword)) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide a valid email and password!',
                accept: 'Ok',
                onAcept: () => setOnAlert(),
            });
            return;
        }

        try {
            const res = await accountLogin({ email: userEmail, password: userPassword });
            console.log(res);
            if (res?.error) {
                setOnAlert({
                    caption: 'Login Failed!',
                    message: res?.error,
                    accept: 'Ok',
                    onAcept: () => setOnAlert(),
                });
              return;
            }
            const accessToken = res?.token;
            localStorage.setItem('accessToken',accessToken);
            window.location.href = "/fr/admin"
        } catch (error) {
            console.log({error});
        }

    }

    useEffect(() => {
        if (isAuthenticated === true)  window.location.href = "/admin";
    }, [isAuthenticated])


    return (
        <div className="app-body">
            <SiteHeader pageTitle={"Login"} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAcept={onAlert.onAcept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="slogan-1 login-cap">CONTENT DE TE REVOIR</div>
            <div className="slogan-2 login-cap">Se connecter</div>
            <div className="login-form-container form-container">
                <form
                    className="login-form app-form"
                    onSubmit={ async (e) => {
                        e.preventDefault();
                        await handleSubmit();
                    }}
                >
                    <FormInput
                        type={'email'}
                        value={userEmail}
                        onChange={(e) => {
                            e.preventDefault();
                            setUserEmail(e.target.value);
                        }}
                        required={true}
                        label={'Email par exemple email@example.com'}
                        name={'email'}
                    />
                    <FormInput
                        type={showPassword ? "text" : "password"}
                        formIcon={showPassword ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowPassword((show) => !show)
                        }}
                        required={true}
                        label={"Mot de passe"}
                        name={"password"}
                        onChange={(e) => {
                            e.preventDefault();
                            setUserPassword(e.target.value);
                        }}
                        value={userPassword}
                    />
                    <div className="action-text forgot">
                        <a href="/fr/sendMail" className="action-link">Mot de passe oublié</a>
                    </div>
                    <button
                        className="form-button"
                        onClick={async () => {
                            await handleSubmit();
                        }}
                    >
                        Se Connecter
                    </button>
                    <div className="action text">
                        <span>Vous n'avez pas de compte ?</span>
                        <a href="/fr/register" className="action-link">S'inscrire</a>
                    </div>
                </form>
            </div>
        </div>
    )
}